import Vue from 'vue'
import Vuex from 'vuex'
import state from './modules/state'
import main from './modules/main'
import facilities from './modules/facilities'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    state,
    main,
    facilities
  }
})
